import React, { memo } from 'react'

import Title from 'components/CommonUI/Title/Title'

import TableSection from './TableSection'
import ChartSection from './ChartSection'

const PageBody = () => {
  return (
    <div className="equpment_body_container">
      <Title
        title="Consumption"
        component="h2"
        className="equpment_body_title"
      />
      <ChartSection />
      <TableSection />
    </div>
  )
}

export default memo(PageBody)
